import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { ModelLayout } from '../components/ModelLayout';
import { useModelSizeService } from '../services/useModelSizeService';

export interface ModelSizeContainerProps {}

export const ModelSizeContainer: React.FC<React.PropsWithChildren<ModelSizeContainerProps>> = () => {
  const { isHide, modelList, onClickMore, targetRef, displayButton, displayCount } = useModelSizeService();
  if (isHide) {
    return null;
  }

  return (
    <Wrapper ref={targetRef}>
      <ModelLayout
        modelList={modelList}
        onClickMore={onClickMore}
        displayCount={displayCount}
        displayButton={displayButton}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 0 16px 0;
  background-color: ${vars.color.backgroundSurface};
`;
